'use client'

import { memo, forwardRef } from 'react'
import styled from 'styled-components'
import { mq, vw, getP18 } from '@/styles'
import type { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
  title?: string
  option: string
  readonly register?: UseFormRegisterReturn
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  ref?: React.RefObject<HTMLInputElement>
  active?: boolean
}

export const RadioCheckBoxes = memo<Props>(forwardRef(({ active = true, title = '', option, register = null, onBlur = null, onChange = null }, ref) => {
  return (
    <label>
      <Input type='checkbox' disabled={!active} name={title} value={option} onBlur={onBlur} onChange={onChange} ref={ref} {...(register && { ...register })}/>
      <span>
        <span>
          <svg viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Oval</title>
            <g id="Symbols" stroke="none" strokeWidth="1">
              <g id="Radiobutton" transform="translate(0.000000, -9.000000)" stroke="#4D4D4D" strokeWidth="0.5">
                <circle id="Oval" cx="5" cy="14" r="4.75"></circle>
              </g>
            </g>
          </svg>
        </span>
        <span>{option}</span>
      </span>
    </label>
  )
}))


const Input = styled.input`
  opacity: 0;
  padding: 0;
  width: 0;
  pointer-events: none;


  + span {
    ${getP18()}
    margin-top: -${vw(22, 'mobile')};
    display: flex;
    place-items: center;
    cursor: pointer;
    transition: opacity 300ms var(--transition-ease);
    overflow: initial !important;

    ${mq.greaterThan('tablet')}{
      margin-bottom: ${vw(3, 'desktop')};
      margin-top: -${vw(24, 'desktop')};
    }


    span {
      display: inline !important;
      overflow: initial !important;

      &:first-of-type {
        align-self: baseline;
        margin-right: ${vw(14, 'mobile')};

        ${mq.greaterThan('tablet')}{
          margin-right: ${vw(14, 'desktop')};
        }
      }
    }

    svg {
      margin-bottom: ${vw(2, 'mobile')};
      width: ${vw(10, 'mobile')};
      height: ${vw(10, 'mobile')};

      ${mq.greaterThan('tablet')}{
        margin-bottom: ${vw(2, 'desktop')};
        width: ${vw(10, 'desktop')};
        height: ${vw(10, 'desktop')};
      }

      #Symbols {
        fill: transparent;
        fill-rule: evenodd;
        transition: fill 100ms var(--transition-ease);;
      }
    }
  }

  &.active + span svg #Symbols, &:checked + span svg #Symbols {
    fill: #4D4D4D;
  }

  &:not(&.active)&:not(:checked):not([disabled]):hover + span svg #Symbols {
    fill: #4d4d4d33;
  }

  &[disabled] + span {
    opacity: .4;
    pointer-events: none;
    user-select: none;
  }
`
